import type { HTMLAttributes, JSX } from "react";

import { type RecipeVariantProps } from "@mobsuccess-devops/styled-system/css";

import { styles } from "./styles";

type DotProps = RecipeVariantProps<typeof styles> & HTMLAttributes<HTMLElement>;

export function Dot({
  delay,
  size,
  color,
  shown,
  ...rest
}: DotProps): JSX.Element {
  const classes = styles({ delay, size, color, shown });
  return (
    <div className={classes.root} role="progressbar" {...rest}>
      <div className={classes.shadow} />
      <div aria-label="ball" className={classes.ball} />
    </div>
  );
}
